const api = {
    // 素材相关
    resource: {
        upload: '/resource/video/upload',
        createLabel: '/resource/createLabel',
        fileList: '/resource/fileList',
        labelList: '/resource/labelList',
        deleteFiles: '/resource/deleteFiles',
        deleteLabels: '/resource/deleteLabels',
        renameFile: '/resource/renameFile',
        renameLabel: '/resource/renameLabel',
        moveFiles: '/resource/moveFiles',
        copyFiles: '/resource/copyFiles',
        search: '/resource/search',
    },
    // 布局相关
    layout: {
        upload: '/layout/upload',
        mkdir: '/layout/mkdir',
        list: '/layout/list',
        delete: '/layout/delete',
        rename: '/layout/rename',
        move: '/layout/move',
        copy: '/layout/copy',
        search: '/layout/search',
    },
    // 施工点相关
    site: {
        list: '/site/list',
        search: '/site/search',
        add: '/site/add',
        edit: '/site/edit',
        enable: '/site/enable',
    },
    // 设备相关
    device: {
        import: '/device/importFile',
        list: '/device/list',
        reset: '/device/reset',
        bind: '/device/bind',
        auth: '/device/auth',
        unbind: '/device/unbind',
        search: '/device/search',
        download: 'https://xiaochengxu.ivideocity.com/api/device/getAuthFile',
    },
    // 代理商相关
    agent: {
        list: '/agent/list',
        add: '/agent/add',
        edit: '/agent/edit',
        enable: '/agent/enable',
        search: '/agent/search',
        authDetail: '/agent/getStatisList',
    },
    // 用户相关
    user: {
        login: '/user/login',
        getCode: '/user/getCode',
        resetPwd: '/user/resetPwd',
        logout: '/user/logout',
        add: '/user/add',
        modifyRole: '/user/modifyRole',
        list: '/user/list',
        enable: '/user/enable',
        info: '/user/info',
    },
    // 版本相关
    version: {
        add: '/version/add',
        list: '/version/list',
        online: '/version/online',
        update: '/version/update',
    },
};

export default api;
